import React, { ReactNode } from "react";
import { Filter, IRecurringInvoiceFilter } from "../../../@types/invoice";
import ListHead from "./ListHead";
import { ReusableTable } from "../../table";
import { ReusableTableColumn } from "../../../@types/table";
import { ICustomer, IPaginationMeta } from "../../../@types";
import { FilterOption } from "./ListFilter";
import EmptyPage from "../../emptyPage/EmptyPage";
import emptySearch from "../../../assets/icons/svgicons/searchEmpty.svg";
import { Button } from "../../common";
import ListPageEmptyTable from "../../emptyPage/ListPageEmptyTable";

interface ListDesktopTableProps {
  data: any[];
  handleSearch?: (text: string) => void;
  handleFilter?: (filter: Filter) => void;
  tableTitle?: string;
  handleSearchSelect?: (item: any) => void;
  isSearching?: boolean | undefined;
  searchedDone?: boolean | undefined;
  setSearchedDone?: (searchedDone: boolean) => void;
  searchResult: any[];
  searchDisplayKey: string;
  searchPlaceHolder: string;
  columns: ReusableTableColumn[];
  modules?: string;
  isLoadingMore: boolean;
  isLoadingFilter: boolean;
  showFilter: boolean;
  fetchMoreData?: (direction: "up" | "down") => void;
  meta?: IPaginationMeta;
  selectedFilter?: Filter | IRecurringInvoiceFilter | undefined;
  categories?: FilterOption[];
  onSubmit?: (filter: Record<string, string | boolean>) => void;
  clearAllFilters?: () => void;
  renderActionMenu?: (
    row: Record<string, any>,
    toggleVisibility: () => void,
    isVisible: boolean,
  ) => React.ReactNode;
  emptyStateDescription?: string;
  emptyPageIcon?: ReactNode;
  emptyPageHref?: string;
  emptyPageLinkName?: string;
  emptyMessage?: string;
  searchText?: string;
  handleSetCustomer: (selectedCustomer: ICustomer | null) => void;
  emptyPageOnClose?: () => void;
  pageTitle: string;
  hasData?: boolean;
  handleCreate: () => void;
  // onTableSearch?: (searchTerm: string) => void;
}

const ListDesktopTable: React.FC<ListDesktopTableProps> = (props) => {
  const [data, setData] = React.useState<typeof props.data>([]);
  const [searchText, setSearchText] = React.useState("");
  const [isActive, setIsActive] = React.useState(false);

  const triggerState = () => {
    setIsActive(true);
    setTimeout(() => {
      setIsActive(false);
    }, 2000);
  };

  const handleClearSelection = () => {
    setSearchText("");
    props.handleSearch?.("");
    triggerState();
  };

  React.useEffect(() => {
    setData([...props.data]);
  }, [props.data]);

  const fetchPageData = async (direction: "up" | "down") => {
    if (direction === "down" && props?.meta?.hasMoreData) {
      props.fetchMoreData ? props.fetchMoreData("down") : undefined;
    }
  };

  const clearFilters = () => {
    props.handleFilter?.({} as Filter);
    props.clearAllFilters?.();
  };
  return (
    <>
      <div
        className={`border border-gray-200 mt-8 ${data.length > 0 ? "rounded-t-xl" : "rounded-xl"} `}
      >
        <ListHead
          handleSearchSelect={props.handleSearchSelect}
          handleSearch={props.handleSearch}
          tableTitle={props.tableTitle}
          searchResult={props.searchResult}
          searchDisplayKey={props.searchDisplayKey}
          handleFilter={props.handleFilter}
          searchPlaceHolder={props.searchPlaceHolder}
          isSearching={props.isSearching}
          searchedDone={props.searchedDone}
          setSearchedDone={props.setSearchedDone}
          categories={props.categories}
          filter={props.selectedFilter}
          onSubmit={props.onSubmit}
          showFilter={props.showFilter}
          clearAllFilters={props.clearAllFilters}
          setSearchText={setSearchText}
          searchText={searchText}
          handleClearSelection={handleClearSelection}
          // onSearch={props.onTableSearch}
        />
        <hr className="border border-gray-200 mt-4" />
        {data.length > 0 || isActive ? (
          <>
            <div className=" lg:block" style={{ overflow: "hidden" }}>
              <ReusableTable
                hasActions={false}
                modules={props.modules}
                data={data}
                columns={props.columns}
                isLoading={props.isLoadingMore}
                isLoadingFilter={props.isLoadingFilter}
                loadMore={fetchPageData}
                renderActionMenu={props.renderActionMenu}
              />
            </div>
          </>
        ) : (
          <div className=" border-gray-200">
            {searchText ? (
              <div className="bg-[#ffffff] mt-[16px]  mb-[80px] pt-[80px]">
                <div className="flex flex-col justify-center text-center items-center mb-[40px]">
                  <img src={emptySearch} alt="" />
                  <p className="text-[20px] text-[#000000] font-medium my-3">
                    No search results
                  </p>
                  <p className="text-[16px] text-[#667085] mb-3 max-w-60">
                    Your search "{searchText}" did not match. Please try again
                  </p>
                  <div className="text-center w-[208px] sm:w-[434px] md:px-0 md:w-[24.3%]">
                    <Button onClick={handleClearSelection} variant="secondary">
                      Clear search
                    </Button>
                  </div>
                </div>
              </div>
            ) : (
              <ListPageEmptyTable
                pageTitle={props.pageTitle}
                description={props.emptyStateDescription}
                pageIcon={props.emptyPageIcon}
                href={props.emptyPageHref}
                linkName={
                  props.emptyPageLinkName ? props.emptyPageLinkName : ""
                }
                handleSetCustomer={props.handleSetCustomer}
                onClose={props.emptyPageOnClose}
                emptyMessage={props.emptyMessage}
                hasData={props.hasData}
                handleCreate={props.handleCreate}
                clearFilters={clearFilters}
              />
            )}
          </div>
        )}
      </div>
      {data.length == 0 && <div className="h-40"></div>}
    </>
  );
};

export default ListDesktopTable;
